import type {CreateBranchButtonProps} from '@github-ui/create-branch-button'
import {type PropsWithChildren, createContext, use} from 'react'

const CreateBranchButtonOptionContext = createContext<CreateBranchButtonProps | null>(null)

export function CreateBranchButtonOptionProvider({
  options,
  children,
}: PropsWithChildren<{options: CreateBranchButtonProps}>) {
  return <CreateBranchButtonOptionContext value={options}>{children}</CreateBranchButtonOptionContext>
}

export function useCreateBranchButtonOptions() {
  const context = use(CreateBranchButtonOptionContext)

  if (!context) {
    throw new Error('useCreateBranchButtonOptions must be used within CreateBranchButtonOptionProvider')
  }

  return context
}

try{ CreateBranchButtonOptionContext.displayName ||= 'CreateBranchButtonOptionContext' } catch {}
try{ CreateBranchButtonOptionProvider.displayName ||= 'CreateBranchButtonOptionProvider' } catch {}